/**
 * Les deltas d'une action, empilés en bas à droite (SPEC-UI §2).
 *
 * ⟦C57 · lot 3 · A-174⟧ **Un plafond d'empilement.** Les toasts s'empilaient sans limite (4,2 s
 * chacun) : une nuit de jeu qui produit six faits couvrait le coin de l'écran, et « on ne lit plus
 * rien ». Au plus `TOASTS_VISIBLES` plaques à la fois, les PLUS RÉCENTES ; les plus anciennes
 * restent dans le store (leur minuteur les retire comme avant, rien n'est perdu : le fait est aussi
 * dans le Journal) et un compteur « +N » dit combien attendent derrière. Chaque plaque tient en une
 * phrase (les lignes de `game/journal.ts` qui deviennent des toasts sont des phrases de 12 mots au plus).
 */

import { useUIStore } from "../stores/uiStore";

/** Au plus 3 plaques à l'écran : de quoi lire, jamais de quoi couvrir la chambre. */
export const TOASTS_VISIBLES = 3;

export function Toasts() {
  const toasts = useUIStore((s) => s.toasts);
  const retirer = useUIStore((s) => s.retirerToast);

  if (toasts.length === 0) return null;

  const visibles = toasts.slice(-TOASTS_VISIBLES);
  const caches = toasts.length - visibles.length;

  return (
    <div className="toasts" role="status" aria-live="polite">
      {caches > 0 ? (
        <span className="toast-reste" title="Les autres sont dans le Journal">
          +{caches}
        </span>
      ) : null}
      {visibles.map((t) => (
        <button
          key={t.id}
          type="button"
          className={`toast ton-${t.ton}`}
          onClick={() => retirer(t.id)}
          title="Fermer"
        >
          <span className="toast-icone" aria-hidden="true">
            {t.icone}
          </span>
          <span>{t.texte}</span>
        </button>
      ))}
    </div>
  );
}
